import { Routes, Route, Navigate } from 'react-router-dom'
import { AppLayout } from './components/layout/AppLayout'
import { useAuthStore } from './store/authStore'

// Pages
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { KundenListePage } from './pages/kunden/KundenListePage'
import { KundeDetailPage } from './pages/kunden/KundeDetailPage'
import { BesuchePlanungPage } from './pages/besuche/BesuchePlanungPage'
import { BesuchFormPage } from './pages/besuche/BesuchFormPage'
import { BesuchDetailPage } from './pages/besuche/BesuchDetailPage'
import { InventarListePage } from './pages/inventar/InventarListePage'
import { GeraetDetailPage } from './pages/inventar/GeraetDetailPage'
import { GeraetFormPage } from './pages/inventar/GeraetFormPage'
import { DefekteListePage } from './pages/defekte/DefekteListePage'
import { DefektDetailPage } from './pages/defekte/DefektDetailPage'
import { DefektFormPage } from './pages/defekte/DefektFormPage'
import { ErsatzteileListePage } from './pages/ersatzteile/ErsatzteileListePage'
import { OffertenListePage } from './pages/offerten/OffertenListePage'
import { OffertFormPage } from './pages/offerten/OffertFormPage'
import { OffertDetailPage } from './pages/offerten/OffertDetailPage'
import { FAQPage } from './pages/faq/FAQPage'
import { MehrPage } from './pages/MehrPage'
import { EinstellungenPage } from './pages/einstellungen/EinstellungenPage'
import { BenutzerPage } from './pages/einstellungen/BenutzerPage'
import { ServiceListePage } from './pages/service/ServiceListePage'
import { ServiceFormPage } from './pages/service/ServiceFormPage'
import { ServiceDetailPage } from './pages/service/ServiceDetailPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn())
  if (!isLoggedIn) return <Navigate to="/login" replace />
  return <AppLayout>{children}</AppLayout>
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user)
  if (!user) return <Navigate to="/login" replace />
  if (user.rolle !== 'admin') return <Navigate to="/" replace />
  return <AppLayout>{children}</AppLayout>
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />

      <Route path="/kunden" element={<ProtectedRoute><KundenListePage /></ProtectedRoute>} />
      <Route path="/kunden/:id" element={<ProtectedRoute><KundeDetailPage /></ProtectedRoute>} />

      <Route path="/besuche" element={<ProtectedRoute><BesuchePlanungPage /></ProtectedRoute>} />
      <Route path="/besuche/neu" element={<ProtectedRoute><BesuchFormPage /></ProtectedRoute>} />
      <Route path="/besuche/:id" element={<ProtectedRoute><BesuchDetailPage /></ProtectedRoute>} />

      <Route path="/inventar" element={<ProtectedRoute><InventarListePage /></ProtectedRoute>} />
      <Route path="/inventar/neu" element={<ProtectedRoute><GeraetFormPage /></ProtectedRoute>} />
      <Route path="/inventar/:id" element={<ProtectedRoute><GeraetDetailPage /></ProtectedRoute>} />

      <Route path="/defekte" element={<ProtectedRoute><DefekteListePage /></ProtectedRoute>} />
      <Route path="/defekte/neu" element={<ProtectedRoute><DefektFormPage /></ProtectedRoute>} />
      <Route path="/defekte/:id" element={<ProtectedRoute><DefektDetailPage /></ProtectedRoute>} />

      <Route path="/ersatzteile" element={<ProtectedRoute><ErsatzteileListePage /></ProtectedRoute>} />

      <Route path="/offerten" element={<ProtectedRoute><OffertenListePage /></ProtectedRoute>} />
      <Route path="/offerten/neu" element={<ProtectedRoute><OffertFormPage /></ProtectedRoute>} />
      <Route path="/offerten/:id" element={<ProtectedRoute><OffertDetailPage /></ProtectedRoute>} />

      <Route path="/service" element={<ProtectedRoute><ServiceListePage /></ProtectedRoute>} />
      <Route path="/service/neu" element={<ProtectedRoute><ServiceFormPage /></ProtectedRoute>} />
      <Route path="/service/:id" element={<ProtectedRoute><ServiceDetailPage /></ProtectedRoute>} />

      <Route path="/faq" element={<ProtectedRoute><FAQPage /></ProtectedRoute>} />
      <Route path="/mehr" element={<ProtectedRoute><MehrPage /></ProtectedRoute>} />
      <Route path="/einstellungen" element={<AdminRoute><EinstellungenPage /></AdminRoute>} />
      <Route path="/einstellungen/benutzer" element={<AdminRoute><BenutzerPage /></AdminRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
